import {Suspense} from "react";
import Header from "./components/header";
import Footer from "./components/footer";
import Headroom from "react-headroom";
import AppRoutes from "./routes/AppRoutes";
import ScrollToTop from "react-scroll-to-top";
import {Route, Routes, useLocation} from "react-router-dom";
import "./assets/css/style.css";
import PrivacyPolicy from "./pages/terms-condition";
const App = () => {
    const location = useLocation();
    const showButton = location.pathname !== "/contact-us";
    console.log = () => {};
    console.error = () => {};
    console.debug = () => {};
    console.warn = () => {};
    return (
        <Suspense fallback={"Loading..."}>
            {/* <ScrollToTop
        smooth
        color="#7CB6E1"
        height={'20px'}
        width="20px"
      /> */}
            {/* header */}
            {/* <Headroom style={{ zIndex: 999 }}>
      </Headroom> */}
            {/* <Header showButton={showButton} /> */}
            {/* pages */}
            <div style={{minHeight: "85vh"}}>
                <AppRoutes />
            </div>
            {/* footer */}
            {/* <Footer /> */}
        </Suspense>
    );
};
export default App;
